import {
  ChartMark,
  WidgetKind,
  type Filters,
  type Report,
  type WidgetOf,
} from 'corso-admin-ui';
import { ClaimStatusEnum } from 'corso-types';

const { closedReordered, closedRefunded, closedDenied, closedResolved } =
  ClaimStatusEnum;

const closed = {
  statuses: [closedReordered, closedRefunded, closedDenied, closedResolved],
} satisfies Filters<'shippingClaims'>;

const claimsClosedAs = (title: string, statuses: ClaimStatusEnum[]) =>
  ({
    kind: WidgetKind.kpi,
    title,
    metric: 'claims',
    filters: { statuses },
  }) as const satisfies WidgetOf<'shippingClaims'>;

export const claims = {
  key: 'claims',
  label: 'Claims',
  dataset: 'shippingClaims',
  timeFields: ['resolvedOn'],
  widgets: [
    claimsClosedAs('Reordered and refunded claims', [
      closedReordered,
      closedRefunded,
    ]),
    claimsClosedAs('Reordered claims', [closedReordered]),
    claimsClosedAs('Refunded claims', [closedRefunded]),
    {
      kind: WidgetKind.kpi,
      metric: 'totalClaimAmount',
      filters: closed,
    },
    {
      kind: WidgetKind.kpi,
      metric: 'reorderAmount',
      filters: closed,
    },
    {
      kind: WidgetKind.kpi,
      metric: 'refundAmount',
      filters: closed,
    },
    { kind: WidgetKind.kpi, metric: 'avgReorderAmount' },
    { kind: WidgetKind.kpi, metric: 'avgRefundAmount' },
    {
      kind: WidgetKind.overTime,
      title: 'Resolved claims over time',
      mark: ChartMark.line,
      metrics: ['claims'],
      filters: closed,
    },
    {
      kind: WidgetKind.overTime,
      title: 'Reorder and refund amounts over time',
      mark: ChartMark.line,
      metrics: ['refundAmount', 'reorderAmount'],
    },
    {
      kind: WidgetKind.ranking,
      title: 'Claims by reason',
      dimension: 'reason',
      metric: 'claims',
    },
    {
      kind: WidgetKind.ranking,
      title: 'Claims by resolution',
      dimension: 'status',
      metric: 'claims',
    },
    {
      kind: WidgetKind.ranking,
      title: 'Claims by source',
      dimension: 'source',
      metric: 'claims',
    },
  ],
} as const satisfies Report;
